/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Chip } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import CheckIcon from '@mui/icons-material/Check';
import { styled } from '@mui/material/styles';
import { colors } from '../../theme/color-palette';
import TextField from '@mui/material/TextField';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import ListSubheader from '@mui/material/ListSubheader';
import Popper from '@mui/material/Popper';
import { VariableSizeList } from 'react-window';
import Typography from '@mui/material/Typography';
import {
	saveSearchedHierarchy,
	openHierarchy,
	setSelectedHierarchy as userSelectedHierarchy,
	clearSearchedHierarchy,
	clickApplyButton,
} from '../../redux/actions/fullCompanyViewAction';
import { setSelectedUPC } from '../../redux/actions/salesActions';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { 
	BOGLE_REGULAR,
	MAIN_INSIGHTS_DASHBOARD,
 } from '../../constants/constant';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
import { UserPortalContext } from '../../context/appcontext';
import analytics from '../../helper/analytics';
import tracker from '../../constants/tracker';

const {
	PURPLE,
	TOGGLE_ACTIVE,
	DARK_ASH,
	GREY,
	LIGHT_GREY,
	LIGHT_GREY1,
	LIST_CLR,
	LIST_BORDER_CLR,
	DISABLE_GREY,
} = colors;

const LISTBOX_PADDING = 8; // px

const useStyles = makeStyles(() => ({
	buttonsWrapper: {
		display: 'flex',
		justifyContent: 'end',
		padding: '16px',
		columnGap: '10px',
		borderTop: `1px solid ${LIGHT_GREY}`,
	},
	cancelButton: {
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontSize: '14px !important',
		textTransform: 'none !important',
		borderRadius: '25px !important',
		borderColor: `${LIGHT_GREY1} !important`,
		color: `${PURPLE} !important`,
		fontWeight: '600 !important',
		boxShadow: 'unset !important',
	},
	applyButton: {
		fontFamily: `${BOGLE_REGULAR} !important`,
		textTransform: 'none !important',
		color: '#fff !important',
		fontSize: '14px !important',
		fontWeight: '600 !important',
		borderRadius: '25px !important',
		boxShadow: 'unset !important',
	},
	dialogStyles: {
		'& .MuiDialog-paper': {
			width: '700px !important',
			zIndex: 9999999999,
		},
	},
	iconsize: {
		fontSize: '20px !important',
	},
	dialogBodyWrapper: {
		fontSize: '24px',
		fontWeight: 700,
		display: 'flex',
		justifyContent: 'space-between',
	},
	dialogActionWrapper: {
		display: 'flex',
		justifyContent: 'end',
		padding: '16px',
		columnGap: '10px',
	},
	discardButtonStyles: {
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontWeight: '600 !important',
		textTransform: 'none !important',
		backgroundColor: `${PURPLE} !important`,
		fontSize: '14px !important',
		borderRadius: '25px !important',
		boxShadow: 'unset !important',
	},
	clearButtonStyles: {
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontSize: '14px !important',
		textTransform: 'none !important',
		color: `${PURPLE} !important`,
		padding: '0px !important',
		minWidth: '45px !important',
	},
	searchInputStyles: {
		'& .MuiInputBase-root': {
			columnGap: '0px',
		},
		'& input': {
			width: '100% !important',
		},
		'& .MuiInput-input': {
			width: '100% !important',
		},
		'& .MuiInputBase-formControl': {
			maxHeight: 199,
			display: 'block',
			overflowY: 'auto',
			overflowX: 'hidden',
		},
		'& .MuiInputBase-input': {
			fontFamily: BOGLE_REGULAR,
			fontSize: '14px',
			paddingTop: '6px !important',
		},
	},
	autocompleteStyles: {
		width: '100% !important',
		position: 'relative',
		'& input': {
			width: '100% !important',
		},
		'& .MuiAutocomplete-endAdornment': {
			top: '0px !important',
			right: '-50px !important',
		},
		'& .MuiAutocomplete-inputRoot': {
			paddingRight: '0px !important',
		},
		'& .MuiAutocomplete-popper': {
			zIndex: 9,
		},
		'& .MuiAutocomplete-clearIndicator': {
			visibility: 'visible !important',
		},
		'& .MuiAutocomplete-root:hover .MuiAutocomplete-clearIndicator': {
			visibility: 'visible !important',
		},
		'& .MuiChip-deleteIcon': {
			fontSize: 13,
		},
		'& .MuiChip-root': {
			color: GREY,
			borderRadius: '2px !important',
			fontFamily: `${BOGLE_REGULAR} !important`,
			height: '26px !important',
			background: `${TOGGLE_ACTIVE} !important`,
			'& .MuiChip-label': {
				color: `${LIST_CLR} !important`,
				fontSize: '14px !important',
				padding: '3px 10px 3px 6px !important',
				fontStyle: 'normal !important',
				fontWeight: 400,
				//lineHeight: '20px !important',
				textTransform: 'lowercase',
				textOverflow: 'ellipsis !important',
				maxWidth: '200px !important',
			},
			'& .MuiSvgIcon-root': {
				fontSize: 20,
				width: 20,
				height: 20,
				color: GREY,
			},
			'& .MuiChip-label:first-line': {
				textTransform: 'capitalize !important',
			},
		},
	},
	leftListLable: {
		fontSize: '14px',
		'&:first-line': {
			textTransform: 'capitalize !important',
		},
	},
	dialogCloseIcon: {
		cursor: 'pointer !important',
	},
	searchIconWrapper: {
		display: 'flex !important',
		'& .MuiSvgIcon-root': {
			fontSize: '20px !important',
		},
	},
	autocompleteWrapper: {
		display: 'flex',
		columnGap: '5px',
		alignItems: 'start',
		flexDirection: 'row',
	},
	parentWrapper: {
		width: '100%',
	},
	checkboxStyles: {
		position: 'relative !important',
		right: `0px !important`,
		fontSize: '14px !important',
	},
	listWrapper: {
		marginTop: '4px',
		display: 'flex !important',
		justifyContent: 'space-between !important',
		alignItems: 'center !important',
		width: '100% !important',
		textTransform: 'lowercase',
	},
	stickyHeaderListStyles: {
		color: `${GREY} !important`,
		fontFamily: 'Bogle !important',
		fontSize: '10px !important',
		fontStyle: 'normal !important',
		fontWeight: 400,
		lineHeight: '14px !important',
	},
}));

const SearchHierarchy = (props) => {
	const classes = useStyles();
	const [latestList, setLatestList] = useState([]);
	const [open, setOpen] = useState(false);
	const [inputValue, setInputValue] = React.useState();
	const dispatch = useDispatch();
	const savedSearchedHierarchy = useSelector(
		(state) => state.fullCompanyViewReducer?.searchedHierarchy
	);
	const applyBtnView = useSelector(
		(state) => state.fullCompanyViewReducer?.applyBtnView
	);
	const [val, setValue] = React.useState(savedSearchedHierarchy);
	const [isBackEvent, setIsBackEvent] = useState(false);
	const portalUserContext = React.useContext(UserPortalContext);

	function renderRow(props) {
		const { data, index, style } = props;
		const dataSet = data[index];
		const inlineStyle = {
			...style,
			top: style.top + LISTBOX_PADDING,
		};
		if (dataSet.hasOwnProperty('group')) {
			return (
				<>
					<ListSubheader
						key={dataSet.key}
						component="div"
						style={{
							...inlineStyle,
							lineHeight: '25px',
							borderTop: `1px solid ${LIST_BORDER_CLR}`,
						}}>
						{dataSet.group}
					</ListSubheader>
				</>
			);
		}
		return (
			<>
				<Typography
					component="li"
					{...dataSet[0]}
					noWrap
					style={{ ...inlineStyle, paddingTop: '8px', paddingBottom: '8px' }}>
					<Box sx={{ width: '100%' }} className="autoCompleteList">
						<Box
							sx={{
								color: GREY,
								fontFamily: 'Bogle',
								fontSize: '10px',
								fontStyle: 'normal',
								fontWeight: 400,
								lineHeight: '14px',
							}}
							className="autoCompleteList">
							{dataSet[1]?.superParent
								? `${dataSet[1]?.superParentId} ${dataSet[1]?.superParent} > ${dataSet[1]?.parentId} ${dataSet[1]?.parent}`
								: dataSet[1]?.parent
								? `${dataSet[1]?.parentId} ${dataSet[1]?.parent}`
								: ''}
						</Box>
						<Box className={`autoCompleteList ${classes.listWrapper}`}>
							<Box
								component={'span'}
								className={`autoCompleteList ${classes.leftListLable}`}>
								{dataSet[1]?.id} {dataSet[1]?.name}
							</Box>
							{val &&
								[...val]?.some((item) => item?.name === dataSet[1]?.name) && (
									<CheckIcon className={classes.checkboxStyles} />
								)}
						</Box>
					</Box>
				</Typography>
			</>
		);
	}

	const OuterElementContext = React.createContext({});

	const OuterElementType = React.forwardRef((props, ref) => {
		const outerProps = React.useContext(OuterElementContext);
		return <div ref={ref} {...props} {...outerProps} />;
	});

	function useResetCache(data) {
		const ref = React.useRef(null);
		React.useEffect(() => {
			if (ref.current != null) {
				ref.current.resetAfterIndex(0, true);
			}
		}, [data]);
		return ref;
	}

	// Adapter for react-window
	const ListboxComponent = React.forwardRef(function ListboxComponent(
		props,
		ref
	) {
		const { children, ...other } = props;
		const itemData = [];
		children.forEach((item) => {
			itemData.push(item);
			itemData.push(...(item.children || []));
		});

		const itemCount = itemData?.length;
		const itemSize = 50;
		const getChildSize = (child) => {
			if (child.hasOwnProperty('group')) {
				return 25;
			}
			return itemSize;
		};
		const getHeight = () => {
			if (itemCount > 8) {
				return 8 * itemSize;
			}
			return itemData?.map(getChildSize).reduce((a, b) => a + b, 0);
		};
		const gridRef = useResetCache(itemCount);
		return (
			<div ref={ref}>
				<OuterElementContext.Provider value={other}>
					{inputValue?.length > 3 && (
						<VariableSizeList
							itemData={itemData}
							height={getHeight() + 2 * LISTBOX_PADDING}
							width="100%"
							ref={gridRef}
							outerElementType={OuterElementType}
							innerElementType="ul"
							itemSize={(index) => getChildSize(itemData[index])}
							overscanCount={5}
							itemCount={itemCount}>
							{renderRow}
						</VariableSizeList>
					)}
				</OuterElementContext.Provider>
				{val?.length > 0 && applyBtnView && (
					<Box className={classes.buttonsWrapper}>
						<Button
							data-test-id="search-hierarchy-cancel"
							onClick={handleBackBtnDialog}
							variant="outlined"
							className={classes.cancelButton}>
							Cancel
						</Button>
						<Button
							data-test-id="search-hierarchy-apply"
							onClick={handleApply}
							disabled={val?.length > 0 ? false : true}
							variant="contained"
							className={classes.applyButton}
							style={{
								backgroundColor: val?.length > 0 ? PURPLE : DISABLE_GREY,
							}}>
							Apply
						</Button>
					</Box>
				)}
			</div>
		);
	});

	const StyledPopper = styled(Popper)({
		'&.MuiAutocomplete-popper': {
			width: '360px !important',
			left: '6px !important',
			top: '10px !important',
			zIndex: 9,
		},
		[`& .${autocompleteClasses.listbox}`]: {
			boxSizing: 'border-box',
			maxHeight: '300px',
			'& ul': {
				padding: 0,
				margin: 0,
				textTransform: 'lowercase',
				color: LIST_CLR,
				fontFamily: 'Bogle',
				fontSize: '14px',
				fontStyle: 'normal',
				fontWeight: 400,
			},
			'& ul .MuiListSubheader-root': {
				color: DARK_ASH,
				fontFamily: 'Bogle',
				fontSize: '10px',
				fontStyle: 'normal',
				fontWeight: 700,
				textTransform: 'uppercase',
			},
		},
	});

	const inputRef = useRef(null);

	useEffect(() => {
		const handleClick = () => {
			handleDiscardSearchedHierarchy();
		};
		const element = inputRef.current;
		element?.addEventListener('click', handleClick);
		return () => {
			element?.removeEventListener('click', handleClick);
		};
	}, []);

	const options = latestList?.map((option) => {
		const firstLetter = option.level;
		return {
			firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
			...option,
		};
	});

	const hierarchyArr = useSelector(
		(state) => state?.fullCompanyViewReducer?.hierarchy
	);

	useEffect(() => {
		let updatedHierarchyArray = [];
		const dept = [];
		const cat = [];
		const subCat = [];
		props?.hierarchy?.map((item) => {
			if (item?.subHierarchy?.length > 0) {
				const { subHierarchy, ...restProps } = item;
				dept.push({ ...restProps });
				if (subHierarchy?.length > 0) {
					subHierarchy?.map((sub1) => {
						const { subHierarchy, ...restProps1 } = sub1;
						cat.push({ ...restProps1, parent: item.name });
						if (subHierarchy?.length > 0) {
							subHierarchy?.map((sub2) => {
								const { ...restProps2 } = sub2;
								subCat.push({
									...restProps2,
									parent: sub1.name,
									superParent: item.name,
									superParentId: item.id,
								});
							});
						}
					});
				}
			}
		});
		updatedHierarchyArray = [...dept, ...cat, ...subCat];
		setLatestList(updatedHierarchyArray);
	}, [props?.hierarchy]);

	const handleInputChange = (event, newInputValue) => {
		event?.stopPropagation();
		setInputValue(newInputValue);
		if (newInputValue?.length > 3 || val?.length > 0) {
			setOpen(true);
		} else {
			setOpen(false);
		}
	};

	const handleOpen = () => {
		if (inputValue?.length > 3) {
			setOpen(true);
		}
	};

	const handleApply = () => {
		setOpen(false);
		dispatch(setSelectedUPC([]));
		let selectedHierarchyRhid = '';
		val?.forEach((hierarchy) => {
			selectedHierarchyRhid += hierarchy?.nestedId + ',';
		});
		dispatch(
			userSelectedHierarchy({
				name: 'Custom',
				hierarchyFilterRhId: selectedHierarchyRhid?.slice(0, -1),
			})
		);
		const request = {
			event: 'Search',
			event_description: 'Search in Hierarchy',
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
		dispatch(openHierarchy(false));
		dispatch(clickApplyButton(false));
		props?.cancleHeirarchyDropdown();
		props?.setIsApplyBtnClick(true);
		props?.setIsSearchEditMode(false);
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: tracker.ACTION_ON.SEARCH_IN_HIERARCHY,
		});
	};

	useEffect(() => {
		if (val?.length > 0) setOpen(true);
	}, [val]);

	const [backBtnDialog, setBackBtnDialog] = React.useState(false);

	const handleBackBtnDialog = () => {
		setBackBtnDialog(true);
	};

	const handleBackBtnDialogClose = () => {
		setBackBtnDialog(false);
		props?.setIsSearchEditMode(true);
	};

	const handleDiscardSearchedHierarchy = () => {
		setValue([]);
		dispatch(setSelectedUPC([]));
		let selectedHierarchyRhid = '';
		hierarchyArr?.forEach((hierarchy) => {
			selectedHierarchyRhid += hierarchy.nestedId + ',';
		});

		dispatch(
			userSelectedHierarchy({
				name: 'All Departments and Categories',
				hierarchyFilterRhId: selectedHierarchyRhid?.slice(0, -1),
			})
		);
		dispatch(clearSearchedHierarchy([]));
		handleBackBtnDialogClose();
		if (!isBackEvent) {
			setOpen(false);
		}
		props?.cancleHeirarchyDropdown();
		setIsBackEvent(false);
		props?.setIsApplyBtnClick(false);
		props?.setIsSearchEditMode(false);
	};

	const onInputFocus = () => {
		if (!applyBtnView) {
			dispatch(clickApplyButton(true));
		}
	};

	useEffect(() => {
		if (inputValue?.length > 3 || val?.length > 0) {
			props?.setHierarchyFilterList(false);
		} else {
			props?.setHierarchyFilterList(true);
		}
	}, [val, inputValue]);

	useEffect(() => {
		if (inputValue?.length > 3 || val?.length > 0) {
			props?.setHierarchyFilterList(false);
		} else {
			props?.setHierarchyFilterList(true);
		}
	}, [val, inputValue]);

	return (
		<Box className={classes.parentWrapper}>
			<Box className={classes.autocompleteWrapper}>
				<Box
					onClick={() => {
						setIsBackEvent(true);
						handleBackBtnDialog();
					}}
					className={classes.searchIconWrapper}
					sx={{
						cursor: val?.length > 0 ? 'pointer' : 'initial',
						margin: val?.length > 0 ? '6px 5px 0px 0px' : '4px 5px 0px 0px',
					}}>
					{val?.length > 0 || inputValue?.length > 3 ? (
						<ArrowBackIcon className={classes.iconsize} />
					) : (
						<SearchIcon className={classes.iconsize} />
					)}
				</Box>
				<Dialog
					open={backBtnDialog}
					onClose={handleBackBtnDialogClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
					className={classes.dialogStyles}>
					<DialogTitle id="alert-dialog-title">
						<Box className={classes.dialogBodyWrapper}>
							<Box>Discard the unapplied selections?</Box>
							<Box
								onClick={handleBackBtnDialogClose}
								className={classes.dialogCloseIcon}>
								<CloseIcon />
							</Box>
						</Box>
					</DialogTitle>
					<DialogActions>
						<Box className={classes.dialogActionWrapper}>
							<Button
								onClick={handleBackBtnDialogClose}
								variant="outlined"
								className={classes.cancelButton}>
								Cancel
							</Button>
							<Button
								onClick={handleDiscardSearchedHierarchy}
								variant="contained"
								className={classes.discardButtonStyles}>
								Discard
							</Button>
						</Box>
					</DialogActions>
				</Dialog>
				<Autocomplete
					id="virtualize-demo"
					data-test-id="search-hierarchy"
					forcePopupIcon={false}
					className={classes.autocompleteStyles}
					multiple={true}
					value={val}
					open={open}
					onChange={(event, newValue, reason) => {
						// When user selects an option,
						// already selected value should not set in setValue method as the newValue,

						// if (
						// 	Array.isArray(newValue) &&
						// 	newValue?.length > 1 &&
						// 	reason === 'selectOption'
						// ) {

						// 	const newElementsArray = [...newValue];
						// 	const lastElement = newElementsArray.pop();

						// 	// If the Value is present, do not proceed
						// 	const isElementPresent = newElementsArray.some(
						// 		(element) => element?.id === lastElement?.id
						// 	);
						// 	if (isElementPresent) {
						// 		return;
						// 	}
						// }

						// newValue.forEach((item) => {
						// 	if (item.id !== undefined && item.id !== null){
						// 		canSearch = true;
						// 	}
						// })

						setValue(newValue);
						dispatch(saveSearchedHierarchy(newValue));
						dispatch(clickApplyButton(true));
						if (newValue.length === 0 && props?.isApplyBtnClick) {
							handleDiscardSearchedHierarchy();
						}
					}}
					disableListWrap
					inputValue={inputValue}
					PopperComponent={StyledPopper}
					ListboxComponent={ListboxComponent}
					options={options.sort(
						(a, b) => -b.firstLetter.localeCompare(a.firstLetter)
					)}
					groupBy={(option) =>
						option?.level === 0
							? 'DEPARTMENT'
							: option?.level === 1
							? 'CATEGORY'
							: option?.level === 2
							? 'SUBCATEGORY'
							: ''
					}
					getOptionLabel={(option) => `${option.id} ${option.name}`}
					onOpen={handleOpen}
					onInputChange={handleInputChange}
					renderInput={(params) => (
						<TextField
							{...params}
							className={classes.searchInputStyles}
							fullWidth
							size="small"
							variant="standard"
							autoFocus
							onFocus={onInputFocus}
							InputProps={{ ...params.InputProps, disableUnderline: true }}
							placeholder="Search"
						/>
					)}
					renderOption={(props, option, state) => [props, option, state.index]}
					renderTags={(tagValue, getTagProps) => {
						return tagValue?.map((option, index) => {
							return (
								<Chip
									label={`${option.id} ${option.name}`}
									{...getTagProps({ index })}
									deleteIcon={<CloseIcon />}
								/>
							);
						});
					}}
					renderGroup={(params) => params}
					ListboxProps={{ style: { maxHeight: '400px' } }}
				/>
				<Button
					ref={inputRef}
					onChange={() => {
						dispatch(clearSearchedHierarchy([]));
					}}
					variant="text"
					className={classes.clearButtonStyles}>
					Clear
				</Button>
			</Box>
		</Box>
	);
};

SearchHierarchy.defaultProp = {
	hierarchy: [],
};

SearchHierarchy.propTypes = {
	hierarchy: PropTypes.array,
	cancleHeirarchyDropdown: PropTypes.func,
	isApplyBtnClick: PropTypes.bool,
	setIsApplyBtnClick: PropTypes.func,
	data: PropTypes.object,
	index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	style: PropTypes.string,
	setHierarchyFilterList: PropTypes.func,
	setIsSearchEditMode: PropTypes.func,
};

export default SearchHierarchy;
